export const paginatorPreset = {
  paginator: {
    root: {
      padding: '0.75rem 1.25rem',
      background: '#ffffff',
    },
    css: () => `
      .p-paginator {
        border-top: 1px solid var(--neutral--20);
        justify-content: center;
        gap: 0.25rem;
      }

      .p-paginator .p-paginator-first,
      .p-paginator .p-paginator-prev,
      .p-paginator .p-paginator-next,
      .p-paginator .p-paginator-last {
        min-width: 2.25rem;
        height: 2.25rem;
        border-radius: 0.375rem;
        color: var(--neutral--60);
        border: none;
        background: transparent;
        transition: 0.2s ease;
      }

      .p-paginator .p-paginator-first:hover,
      .p-paginator .p-paginator-prev:hover,
      .p-paginator .p-paginator-next:hover,
      .p-paginator .p-paginator-last:hover {
        background: var(--neutral--5);
        color: var(--neutral--70);
      }

      .p-paginator .p-paginator-first:focus,
      .p-paginator .p-paginator-prev:focus,
      .p-paginator .p-paginator-next:focus,
      .p-paginator .p-paginator-last:focus {
        box-shadow: 0 0 0 3px rgba(21, 93, 252, 0.12);
      }

      .p-paginator .p-paginator-first.p-disabled,
      .p-paginator .p-paginator-prev.p-disabled,
      .p-paginator .p-paginator-next.p-disabled,
      .p-paginator .p-paginator-last.p-disabled {
        opacity: 0.4;
        pointer-events: none;
      }

      .p-paginator .p-paginator-page {
        min-width: 2.25rem;
        height: 2.25rem;
        border-radius: 0.375rem;
        font-weight: 600;
        font-size: 0.875rem;
        color: var(--neutral--60);
        background: transparent;
        border: none;
        transition: 0.2s ease;
      }

      .p-paginator .p-paginator-page:hover {
        background: var(--neutral--5);
        color: var(--neutral--70);
      }

      .p-paginator .p-paginator-page.p-paginator-page-selected {
        background: var(--brand--5);
        color: var(--brand--60);
        font-weight: 700;
        border: none;
      }

      .p-paginator .p-paginator-current {
        color: var(--neutral--50);
        font-size: 0.875rem;
      }
    `,
  },
};
